import * as React from 'react';
import {useDispatch} from 'react-redux';
import InputText from '../../../../../common/components/InputText';
import {CHATS} from '../../../constants/LabelConstants';
import {ERROR_REQUIRED} from '../../../../constants/ValidateConstant';
import Button from '../../../../../common/components/Button';
import {GLOBAL} from '../../../../constants/LabelConstants';
import * as ModalActions from '../../../../../common/actions/ModalActions';
import {Creators as ChatDataActions} from '../../../reducers/chat/data';

const ChatsPinChatView: React.FC<null> = (): React.ReactElement => {
    const dispatch = useDispatch();
    const [reason, setReason] = React.useState('');
    const [showError, setShowError] = React.useState(false);
    const updateMsg = (value) => {
        setShowError(true);
        setReason(value);
    };
    const onSendMsg = () => {
        dispatch(ChatDataActions.updateChatPin(true, reason));
        dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        setReason('');
    };

    return (
        <div className="container pt-4">
            <div className="row">
                <div className="col-12">
                    <InputText
                        label={CHATS.REASON}
                        id="reason"
                        required={true}
                        hasError={showError && reason.length === 0}
                        onChange={updateMsg}
                        labelError={ERROR_REQUIRED}
                        maxLength={15}
                        value={reason}
                    />
                </div>
                <div className="col-12">
                    <Button
                        disabled={reason.length === 0}
                        type="squared"
                        customClass="w-100"
                        text={GLOBAL.ACCEPT}
                        onPress={onSendMsg}
                    />
                </div>
            </div>
        </div>
    );
};

export default ChatsPinChatView;
